<section *ngIf="this.dataSource.length != 0">
  <ul class="scrollable-list">
    <li class="list-item" *ngFor="let item of dataSource; let i = index">
      <span class="name" [ngStyle]="{ color: this.tabPosition === 0 ? 'white' : 'black' }">{{ item.source }}</span>
      <span class="date" [ngStyle]="{ color: this.tabPosition === 0 ? 'white' : 'black' }">{{ item.date }}</span>
    </li>
  </ul>
</section>

<div *ngIf="this.dataSource.length === 0">
  <div class="row">
    <div class="col-12 my-5 space-around-center">
      <h4 [ngStyle]="{ color: this.tabPosition === 0 ? 'white' : 'black' }">Sin registro de {{ this.tabPosition === 0 ? 'jugadas' : 'etickets' }}</h4>
    </div>
  </div>
</div>
